"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTypeLabel = exports.userTypeColors = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const StaffUserType_1 = __importDefault(require("../StaffUserType"));
const SuperUserType_1 = __importDefault(require("../SuperUserType"));
const TeamboardUserType_1 = __importDefault(require("../TeamboardUserType"));
function userTypeColors(userType) {
    switch (userType) {
        case SuperUserType_1.default.SUPERADMIN:
            return lib_palette_1.default.CoralRed;
        case SuperUserType_1.default.SUPERUSER:
            return lib_palette_1.default.OJ;
        case StaffUserType_1.default.PRIMARYADMIN:
            return lib_palette_1.default.Greeny;
        case StaffUserType_1.default.ADMIN:
            return lib_palette_1.default.GoodOldBlue;
        case StaffUserType_1.default.EMPLOYEE:
            return lib_palette_1.default.GreyBlue;
        case TeamboardUserType_1.default.TEAMBOARD:
            return lib_palette_1.default.MellowYellow;
        default:
            return lib_palette_1.default.Liquorice;
    }
}
exports.userTypeColors = userTypeColors;
function userTypeLabel(userType) {
    switch (userType) {
        case SuperUserType_1.default.SUPERADMIN:
            return lib_i18n_1.default.t('usertype-superadmin');
        case SuperUserType_1.default.SUPERUSER:
            return lib_i18n_1.default.t('usertype-superuser');
        case StaffUserType_1.default.PRIMARYADMIN:
            return lib_i18n_1.default.t('usertype-primaryuser');
        case StaffUserType_1.default.ADMIN:
            return lib_i18n_1.default.t('usertype-admin');
        case StaffUserType_1.default.EMPLOYEE:
            return lib_i18n_1.default.t('usertype-employee');
        case TeamboardUserType_1.default.TEAMBOARD:
            return lib_i18n_1.default.t('usertype-teamboard');
    }
}
exports.userTypeLabel = userTypeLabel;
